<label class="leading-normal flex flex-col mt-2" style="min-height: 2rem">
    <div class="flex items-start">
      <input
        class="mr-2 form-checkbox text-primary h-5 w-5"
        type="checkbox"
        style="display: inline; margin-top: 1px;"
        [formControl]="control"
        [ngClass]="{ 'input-error': control.invalid }"
        [attr.aria-label]="field.config.label"
          [attr.data-field]="field?.fieldUuid"
    [attr.data-typeId]="field?.config?.typeId"
        [attr.tabIndex]="0"
      />

      <span class="leading-normal" *ngIf="!hideLabel" [innerHTML]="field.config.label">
      </span>

      <app-tooltip *ngIf="!showDescription" class="ml-1" [content]="field.config.description"></app-tooltip>
      <!-- Boolean fields render their own label (they bypass form-input's label
           block), so the "important for advertising" cue has to be repeated
           here — otherwise required booleans like trade-in / metallic colour
           show no indicator and the user can't tell why they matter
           (BRIEFD-6045). Matches the icon in form-input.component.html. -->
      <span *ngIf="field.config.isImportantForAdvertising && !hideLabel"
            class="form-ad-tag"
            matTooltip="Potrebno za objavo oglasa na vsaj enem portalu."
            i18n-matTooltip
            aria-label="Potrebno za objavo oglasa"
            i18n-aria-label
            i18n>Za oglaševanje</span>
      <!-- Country-scoped tag, repeated here for the same reason as above. -->
      <span *ngIf="field.config.tag && !hideLabel"
            class="form-country-tag"
            matTooltip="Ta podatek je potreben za poročanje in izdajo dokumentov v tej državi."
            i18n-matTooltip
            [attr.aria-label]="field.config.tag">{{ field.config.tag }}</span>
    </div>
    <p *ngIf="showDescription && field.config.description" class="text-xs text-gray-500 mb-1 ml-7" [innerHTML]="field.config.description"></p>
  </label>
